import { create } from 'zustand';
import { adminAuctionApi } from '@api/api-config.ts';
import { AdminAuctionListResponse } from '@api/generated/portal-be-admin';

export interface AuctionFilters {
  code?: string;
  name?: string;
  portalId?: number;
  validTo?: string;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminAuctionStoreState {
  loading: boolean;
  error: string | null;
  data: AdminAuctionListResponse[] | null;
  pagination: PaginationInfo | null;
  loadAuctions: (filters: AuctionFilters) => Promise<void>;
}

export const useAdminAuctionStore = create<AdminAuctionStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,

  loadAuctions: async (filters: AuctionFilters) => {
    try {
      set({ loading: true, error: null });
      const response = await adminAuctionApi.getAuctions({
        page: filters.page,
        size: filters.size,
        code: filters.code,
        name: filters.name,
        portalId: filters.portalId,
        validTo: filters.validTo,
      });
      const result = response.data;
      set({
        loading: false,
        error: null,
        data: result.items || [],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba při načítání aukcí',
      });
    }
  },
}));
